import { Image } from 'react-native'

// Gets rendered image dimenstions of an image using mode 'contain'
export const getActualImageDimensions = async ({ containerWidth, containerHeight, imageUrl }) => {
  return new Promise(resolve => {
    Image.getSize(imageUrl, (width, height) => {
      const containerAspectRatio = containerWidth / containerHeight
      const containerMin = Math.min(containerWidth, containerHeight)
      const containerMax = Math.max(containerWidth, containerHeight)

      const imageAspectRatio = width / height

      let resizedHeight = 0
      let resizedWidth = 0
      if (containerAspectRatio >= imageAspectRatio) {
        if (containerAspectRatio >= 1) {
          resizedHeight = containerMin
          resizedWidth = resizedHeight * imageAspectRatio
        } else {
          resizedWidth = containerMin
          resizedHeight = resizedWidth * imageAspectRatio
        }
      } else {
        if (containerAspectRatio >= 1) {
          resizedWidth = containerMax
          resizedHeight = resizedWidth / imageAspectRatio
        } else {
          resizedHeight = containerMax
          resizedWidth = resizedHeight / imageAspectRatio
        }
      }
      resolve({ width: resizedWidth, height: resizedHeight })
    })
  })
}
